import type { Locale } from 'date-fns'
import type { SRT_Localization } from '../components/master-table'

import { de as datesDe } from 'date-fns/locale/de'
import { enGB as datesEn } from 'date-fns/locale/en-GB'
import { es as datesEs } from 'date-fns/locale/es'
import { uk as datesUk } from 'date-fns/locale/uk'
import { de, en, es, uk } from 'zod/v4/locales'

import { SRT_Localization_DE } from '../components/master-table/locales/de'
import { SRT_Localization_EN } from '../components/master-table/locales/en'
import { SRT_Localization_ES } from '../components/master-table/locales/es'
import { SRT_Localization_UK } from '../components/master-table/locales/uk'

export const dateLocales: Record<string, Locale> = {
	en: datesEn as unknown as Locale,
	uk: datesUk as unknown as Locale,
	de: datesDe as unknown as Locale,
	es: datesEs as unknown as Locale,
}
export const masterTableLocales: Record<string, SRT_Localization> = {
	uk: SRT_Localization_UK,
	en: SRT_Localization_EN,
	de: SRT_Localization_DE,
	es: SRT_Localization_ES,
}

export const zodLocales: Record<string, typeof en> = {
	en,
	uk,
	de,
	es,
}
